import AreaChart from './AreaChart'

export default AreaChart
